var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 8,
    "data-width-20": 10,
    "data-width-24": 13,
    "data-width-28": 16,
    "data-width-32": 17,
    "data-width-36": 20,
    "data-width-40": 29,
    viewBox: "0 0 7.3 7.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m.889.889 5.333 2.666L.889 6.222z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;